import React, { FC, useEffect, useState } from "react";
import {Helmet} from "react-helmet-async";
import Pagination from "shared/Pagination/Pagination";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import SectionSliderCollections from "components/SectionSliderLargeProduct";
import SectionPromo1 from "components/SectionPromo1";
import ProductCard from "components/ProductCard";
import TabFilters, { Filters } from "./TabFilters";
import { Product, PRODUCTS } from "data/data";
import ProductService, { ProductOptions } from "app/services/productService";
import { useSelector } from "react-redux";
import { RootState } from "app/store";
import WishlistService from "app/services/wishlistService";
import { useParams } from 'react-router-dom';

export interface PageCollectionProps {
  className?: any;
}

interface Category {
  id: number;
  name: string;
}


const PageCollection: FC<PageCollectionProps> = ({ className = "" }) => {
  const [products, setProducts] = useState<Product[]>([]);
  const [page, setPage] = useState<number>(0);
  let { market } = useParams();
  let filters:Filters = localStorage.getItem('filters') ? JSON.parse(localStorage.getItem('filters')!) : {
    pages: 0,
    categories:[],
    rangePrices:[1000, 10000],
    size:[],
    discount: false
  }
  const updateData = (data:Filters) =>{
    
    const options: ProductOptions = {
      page: data.pages,
      categories: data.categories?.map(d => d.id).join(),
      price: data.rangePrices?.join(),
      size: data.size?.join(),
      discount: data.discount,
      sort: data.sort,
      market: market
    }
 
    ProductService.getProducts(options).then(data => {

      setProducts(data)
    })
  }
  const loginData = localStorage.getItem('loginData')
  ? JSON.parse(localStorage.getItem('loginData')!)
  : {
    authChecked: false,
    loggedIn: false,
    token: ""
  }
  useEffect(() => {
    try{
      if(loginData.loggedIn)
      WishlistService.getWishlist().then(data =>{

        localStorage.setItem('likes', JSON.stringify(data))
    })
    }catch{

    }
    updateData(filters)
  

  }, [market])

  const plusHandler = () =>{
    const options: ProductOptions = {
      page: page + 1,
      categories: filters.categories?.map(d => d.id).join(),
      price: filters.rangePrices?.join(),
      size: filters.size?.join(),
      discount: filters.discount,
      sort: filters.sort,
      market: market
    }

    ProductService.getProducts(options).then(data => {
      if(data.length > 0){

      }
      setPage(page+1)
      setProducts([...products, ...data])
    })
  }
  return (
    <div
      className={`nc-PageCollection ${className}`}
      data-nc-id="PageCollection"
    >
      <Helmet>
        <title>Roupa || Shop</title>
      </Helmet>

      <div className="container py-16 lg:pb-28 lg:pt-20 space-y-16 sm:space-y-20 lg:space-y-28">
        <div className="space-y-10 lg:space-y-14">
          {/* HEADING */}
     

          <hr className="border-slate-200 dark:border-slate-700" />
          <main>
            {/* TABS FILTER */}
            <TabFilters updateData={updateData} />

            {/* LOOP ITEMS */}
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-10 mt-8 lg:mt-10">
              {products.map((item, index) => (
                <ProductCard data={item} key={index} isLiked={false} />
              ))}
            </div>

            {/* PAGINATION */}
            <div className="flex flex-col mt-12 lg:mt-16 space-y-5 sm:space-y-0 sm:space-x-3 sm:flex-row sm:justify-between sm:items-center">
              {/* <Pagination /> */}
              <div></div>
              <ButtonPrimary onClick={plusHandler}>Voir plus</ButtonPrimary>
            </div>
          </main>
        </div>

        {/* === SECTION 5 === */}
 
      </div>
    </div>
    );
};

export default PageCollection;
